export default __webpack_public_path__ + "static/media/TTAWelcomeBGImageupdated.217bc374.png";